// extracted by mini-css-extract-plugin
export default {"image":"Hgf5JRPp5Xb6i-FL1qijM"};